import type { SupportedVersions } from "../supportedVersions.js";
import { sampleCansComprehensive_1_0 } from "./sample-cans/comprehensive-1-0.js";
import { sampleCansMini_1_0 } from "./sample-cans/mini-1-0.js";
import { sampleCore_1_0 } from "./sample/core-1-0.js";
import { sampleCore_1_1 } from "./sample/core-1-1.js";
import { sampleCore_1_2 } from "./sample/core-1-2.js";

/**
 * Every set of decorators our form applies, each naming the versions it
 * serves. A version no set names is shown through its plain form, losing
 * every rule our form adds, so remove a version only once no draft pins it.
 */
export const supportedByOurForm: readonly SupportedVersions[] = [
  sampleCore_1_0,
  sampleCore_1_1,
  sampleCore_1_2,
  sampleCansComprehensive_1_0,
  sampleCansMini_1_0,
];

/** The language our form's banners fall back to where they have no words in the respondent's. */
export const ourFormFallbackLanguage = "en";
